import React from "react";
import classes from "./EyeIcon.module.css";
import imgClose from "../../assests/ui/eye-close.png" ;
import imgOpen from "../../assests/ui/eye-open.png";

const EyeIcon = ({status, width}) => {
    return <div><img src={`${status==1? imgClose :imgOpen}`} style={{width:width}}></img></div>
}

export default EyeIcon;